import { faPlus } from "@fortawesome/pro-solid-svg-icons"
import ConsultationsList from "../components/Consultations/ConsultationsList"
import HeroButton from "../components/common/HeroButton"
import HeroButtonsContainer from "../components/common/HeroButtonsContainer"
import HeroContainer from "../components/common/HeroContainer"
import { NavigationService } from "../services/navigationService"

export type Props = {
  imgSrc: string
  navigationService: NavigationService
}

const ConsultationsPage = ({imgSrc, navigationService}: Props) => {
  const navigateToNewConsultation = () => {
    navigationService.setUrl('customers#newConsultation')
  }

  return <div id="main" className="main-consultations fluid-container">
    <HeroContainer imgSrc={imgSrc} />
    <div className="hero-details">
      <h1>Consultations</h1>
      <HeroButtonsContainer>
        <HeroButton icon={faPlus} onClick={navigateToNewConsultation} />
      </HeroButtonsContainer>
    </div>
    <section>
      <ConsultationsList />
    </section>
  </div>
}

export default ConsultationsPage